import React, { useState, useReducer, useEffect, useRef, useMemo } from "react";
import { enumUtil } from "../../../utils/Enum";
import Table from "../../Setup/Shared/Table";
import Loader from "../../shared/Loader/Loader";
import GridColumnHeader from "../../Setup/Shared/GridColumnHeader"
import { ServerRequestProtected, ServerRequestPublic } from "../../../utils/ServerDataRequest";
import { useSelector } from "react-redux";
import CalendaRangeInput from "../../General/CalendarRangeInput";
import SearchHeader from '../../Setup/Shared/SearchHeader';
import AmountFormatter from "../../../utils/AmountFormatter";
import NotificationHandler from "../../../utils/NotificationHandler";
import { Autocomplete, TextField } from "@mui/material";
import handleCopyText from "../../shared/CopyData";
import ReactDataGrid from 'react-data-grid';
import { saveAs } from "file-saver";
import SuperSearchList from "../../shared/SuperSearch/SuperSearchList";
import isNull from "../../../utils/NullChecking";
import FormValidator from "../../../utils/FormValidator";
import { connect } from "react-redux"
import CellExpanderFormatter from "../../Billing/Claims/ClaimDetails/CellExpandFormatter";
import Pagination from "../../shared/Pagination/Pagination";
import NoDataFound from "../../shared/NoDataFound/NoDataFound";
import SuperSearchMultiple from "../../shared/SuperSearch/SuperSearchMultiple";
import SuperSearchMultipleClient from "../../shared/SuperSearch/MultipleSelection/SuperSearchMultipleClient";
import usePagination from "../../../customhooks/usePagination";
import HandleSelectColumnName from "../../../utils/HandleSelectColumnName";
import { TabActionClaims } from "../../../actions/BillingActions";

// let SubGridDataObject = {};
// let SubGridData = [];


const PatientList = (props) => {
  const Search_Data = {
    "DOSFrom": null,
    "DOSTo": null,
    "EntryDateFrom": null,
    "EntryDateTo": null,
    "SubmittedFrom": null,
    "SubmittedTo": null,
    "PatientID": "-1",
    "CPT": "",
    "GroupBy": 'DOS',
    "DataBy": 'Weekly',
    "InsuranceID": "-1",
    "ResultAs": 'Amounts',
  }
  const API_Reports = enumUtil.controller.Report
  const API_URL_CLAIM = enumUtil.controller.Claim
  const API_URL_Patient = enumUtil.controller.Patient
  const API_URL_GENERAL = enumUtil.controller.General


  const { type, Settings } = { ...props };
  const { paginationSection, PerPage, PageNo, TotalPages, handlePageClick, PreviousPage, NextPage, handleFingByCreteria, setTotalPages, handleSelectData } = usePagination(Settings.PaginationDefaultRows);

  let ActiveReport = useSelector(state => state.Open_Report_Tab?.find((re) => re.active));
  let SidebarActive = useSelector(state => state.SidebarActiveTab);
  let DropdownData = useSelector(state => state.GeneralDropDownsReducer)
  const [patientListData, setPatientListData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [show, setShow] = useState(false);
  const initialLoad = useRef(false);
  const [searchParam, setSearchParam] = useState(Search_Data)
  const [is, setIs] = useState(false);
  const [patientValue, setPateintValue] = useState([])
  const [PatientDD, setPatientDD] = useState([])
  const [copiedText, setCopiedText] = useState({});
  ////////====FIX: Add state for subgrid data=====//////////
  const [subGridDataObject, setSubGridDataObject] = useState({});
  const [claimRecord, setClaimRecord] = useState([]);

  const radioInputRef = useRef(null);
  const [filterShow, setFilterShow] = useState(false);
  const [dataByWeek, setDataByWeek] = useState("Weekly");

  const [cptBody, setcptBody] = useState({ "TableName": enumUtil.enumAPITableName.Procedure, "SearchParam": '' })

  const [selectedRows, setSelectedRows] = useState(new Set())
  const [selectedClaimId, setSelectedClaimID] = useState([])
  const [reloadSuperSearchPatient, setReloadSuperSearchPatient] = useState(false);
  const [procedureDD, setProcedureDD] = useState([])
  const [selectedCPT, setselectedCPT] = useState('')






  // const [PerPage, setPerPage] = useState(Settings?.PaginationDefaultRows);
  // const [PageNo, setPageNo] = useState(1);
  // const [TotalPages, setTotalPages] = useState(0);
  const [totalCounts, setTotalCounts] = useState()
  const [totalcountSummary, settotalcountSummary] = useState()

  // const handlePageClick = (page) => { setPageNo(page); }
  // const PreviousPage = () => { if (PageNo > 1) setPageNo(PageNo - 1); }
  // const NextPage = () => { if (PageNo < TotalPages) setPageNo(PageNo + 1); }
  // const handleFingByCreteria = (e) => {
  //   setPerPage(e.target.value)
  //   setPageNo(1)
  // }
  ////////====GridColumnHeader=========//////////
  const [gridHeader, handleGridHeader] = useReducer((prev, next) => {
    return { ...prev, ...next }
  }, { defaultData: '', activeSortIcon: '' })
  const handleMultipleSelect = (value, type) => {
    let arr = [];
    if (type === 'PatientID') {
      value.map((key, index) => {
        arr.push(key.value)
      })
      setPateintValue(value);
      setSearchParam({ ...searchParam, PatientID: arr.toString() })
    }
    setPatientDD([])
  }
  useEffect(() => {
    ServerRequestProtected(API_URL_GENERAL + "/DropDown", 'post', {
      "TableName": enumUtil.enumAPITableName.Procedure
    })
      .then((response) => {
        setProcedureDD(response)
      }).catch((error) => {
        // setIsLoading(false)
      })
  }, []);
  const handlePatientInstantSearch = (e) => {
    if (e.target.value.length > 1) {
      ServerRequestProtected(API_URL_CLAIM + "/PatientInstantSearch", 'post', {
        "TableName": enumUtil.enumAPITableName.Patient,
        "SearchParam": e.target.value,
        SearchCriteria: {
          "DisplayDOB": "1"
        }
      })
        .then((response) => {
          setPatientDD(response)
        }).catch((error) => {
          console.log(error)
        })
    } else {
      setPatientDD([]);
    }

  }
  const handleCopy = (row, type) => {
    let name = `${row}-${type}`;
    handleCopyText(type);
    setCopiedText({ ...copiedText, [name]: true });
    setTimeout(() => {
      setCopiedText({ ...copiedText, [name]: false });
    }, 300)
  }
  const handleMUltiSelectedData = (selectedDataArray, type, name) => {
    console.log("selectedDataArray")
    let modal = { ...searchParam };
    if (type === 'server' && selectedDataArray.length > 0) {
      const displayValues = selectedDataArray.map(data => data.display);
      const valueValues = selectedDataArray.map(data => data.value);

      modal[name] = valueValues.join(', ');
      // PatientSaveUpdateModal[name] = valueValues.join(', ');
    } else if (type === 'client' && selectedDataArray.length > 0) {
      const displayValues = selectedDataArray.map(data => data.display);
      const valueValues = selectedDataArray.map(data => data.value);
      modal[name] = valueValues.join(', ');

      // PatientSaveUpdateModal[name] = valueValues.join(', ');
    }
    else {
      console.log("selectedDataArray");
      modal[name] = '';
      // PatientSaveUpdateModal[name] = '';
    }
    setSearchParam(modal);
    // setPatientSaveUpdateModal(PatientSaveUpdateModal);
    return selectedDataArray;
  }
  //////////////////////////////////////////////
  const isEqual = (obj1, obj2) => {
    if (obj1 === obj2) return true;
    if (typeof obj1 !== 'object' || typeof obj2 !== 'object') return false;
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);
    if (keys1.length !== keys2.length) return false;
    for (let key of keys1) {
      if (!keys2.includes(key) || !isEqual(obj1[key], obj2[key])) {
        return false;
      }
    }
    return true;
  };

  const [viewThisPage, setViewThisPage] = useState('true')
  const [allRecordSummary, setAllRecordSummary] = useState({})
  const columns = useMemo(() => {

    return [
      // {
      //     ...SelectColumn,
      //     renderCell({ row, isCellSelected, onRowChange }) {
      //         if (row.type === "MASTER") {
      //             return SelectColumn.renderCell({ row, isCellSelected, onRowChange });
      //         }
      //         return null; // Return null for rows of type 'DETAIL' to hide the checkbox
      //     },

      // },
      {
        key: 'expanded',
        name: '',
        minWidth: 50,
        width: 50,
        resizable: true,
        colSpan(args) {
          // console.log(args,'args');
          return args?.type === 'ROW' && args?.row?.type === 'DETAIL' ? 15 : undefined;
        },
        cellClass(row) {
          return row?.type === 'DETAIL'
            ?
            " padding: 24px;"

            : undefined;
        },
        renderCell({ row, isCellSelected, onRowChange }) {
          if (row?.type === 'DETAIL') {
            return (
              <SubGrid
                isCellSelected={isCellSelected}
                parentId={row?.parentId}
                row={row}
                ////////====FIX: Pass subGridDataObject and claimRecord as props=====//////////
                subGridDataObject={subGridDataObject}
                claimRecord={claimRecord}
              // settSubGridData={subGridData}
              // direction= {direction} 
              />
            );
          }
          return (
            <CellExpanderFormatter
              expanded={row?.expanded}
              isCellSelected={isCellSelected}
              onCellExpand={() => {
                onRowChange(Object.assign(Object.assign({}, row), { expanded: !row.expanded }));
              }}
              ClaimLines={row?.NumOfLines}
            />
          );
        }
      },
      {
        key: 'DateRange',
        name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
          iconName={'icon-card'} headerName={dataByWeek === 'Weekly' ? 'Weekly' : dataByWeek === 'Monthly' ? 'Monthly' : dataByWeek === 'Yearly' ? 'Yearly' : ''} sortIcon={true} type={'string'} colKey={'DateRange'} data={patientListData} setData={setPatientListData} />),
        width: 200,
        resizable: true,
        renderCell: ({ row }) => {
          return (
            <>
              <div className="align-items-center pri_ins copy_icon copy_icon_hover d-flex gap-1 justify-content-between patient_col w-100">
                <div className="copy_icon validation_message">
                  {row.DateRange}
                </div>
                {row.DateRange && <div className="icon_copy">
                  <i className='icon-Icon-ionic-ios-copy' onClick={() => handleCopy(row.LineID, row.DateRange)}></i>
                  <p class="tool_tip xsm_text text-light">Copy</p>
                </div>}
                {copiedText[`${row.LineID}-${row.DateRange}`] ? <p className={`xsm_text copied_text d-block`} >Copied to clipboard</p> : <></>}
              </div>
            </>
          );
        },
        renderSummaryCell() {
          return (
            <>
              <div className="d-flex align-items-center gap-1 za_View">
                <p className='heading'>Total:</p>
                <div className="d-flex gap-2">
                  <div className="ar_radio-btn d-flex align-items-center gap-1">
                    <input
                      type="radio"
                      name="weekly_status"
                      value="true"
                      checked={viewThisPage === 'true'}
                      onChange={(e) => setViewThisPage(e.target.value)}
                    />
                    <p for="Active" className="text fs-12 ar-orange-text" >This Page</p>
                  </div>
                  <div className="ar_radio-btn d-flex align-items-center gap-1">
                    <input
                      type="radio"
                      name="weekly_status"
                      value="false"
                      checked={viewThisPage === 'false'}
                      onChange={(e) => setViewThisPage(e.target.value)} />
                    <p for="InActive" className="text fs-12 ar-orange-text" >All Pages</p>
                  </div>
                </div>
              </div>
            </>

          )
        }
      },
      {
        key: 'InsuranceName',
        name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
          iconName={'icon-card'} headerName={'Insurance'} sortIcon={true} type={'string'} colKey={'InsuranceName'} data={patientListData} setData={setPatientListData} />),
        resizable: true,
        width: 200,
      },
      {
        key: 'Total',
        name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
          iconName={'icon-card'} headerName={'Total'} sortIcon={true} type={'string'} colKey={'Total'} data={patientListData} setData={setPatientListData} />),
        resizable: true,
        renderCell: ({ row }) => {
          return (<>  {searchParam?.ResultAs === 'Count'
            ? row.Total
            : <AmountFormatter amount={row.Total} />
          }</>)
        },
        renderSummaryCell: () => {
          return (
            searchParam?.ResultAs === 'Count'
              ? summaryRow?.Total
              : <AmountFormatter amount={summaryRow?.Total} />
          )
        }
      },
      {
        key: 'Billed',
        name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
          iconName={'icon-card'} headerName={'Billed'} sortIcon={true} type={'string'} colKey={'Billed'} data={patientListData} setData={setPatientListData} />),
        resizable: true,
        renderCell: ({ row }) => {
          return (<> {searchParam?.ResultAs === 'Count'
            ? row.Billed
            : <AmountFormatter amount={row.Billed} />
          }</>)
        },
        renderSummaryCell: () => {
          return (
            searchParam?.ResultAs === 'Count' ? summaryRow?.Billed :
              <AmountFormatter amount={summaryRow?.Billed} />)
        }
      },
      {
        key: 'NotBilled',
        name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
          iconName={'icon-card'} headerName={'Not Billed'} sortIcon={true} type={'string'} colKey={'NotBilled'} data={patientListData} setData={setPatientListData} />),
        resizable: true,
        renderCell: ({ row }) => {
          return (<> {searchParam?.ResultAs === 'Count'
            ? row.NotBilled
            : <AmountFormatter amount={row.NotBilled} />
          }</>)
        },
        renderSummaryCell: () => {
          return (
            searchParam?.ResultAs === 'Count' ? summaryRow?.NotBilled :
              <AmountFormatter amount={summaryRow?.NotBilled} />)
        }
      },
      {
        key: 'Rejected',
        name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
          iconName={'icon-card'} headerName={'Rejected'} sortIcon={true} type={'string'} colKey={'Rejected'} data={patientListData} setData={setPatientListData} />),
        resizable: true,
        renderCell: ({ row }) => {
          return (<> {searchParam?.ResultAs === 'Count'
            ? row.Rejected
            : <AmountFormatter amount={row.Rejected} />
          }</>)
        },
        renderSummaryCell: () => {
          return (
            searchParam?.ResultAs === 'Count' ? summaryRow?.Rejected :
              <AmountFormatter amount={summaryRow?.Rejected} />)
        }
      },
      {
        key: 'Farwarded',
        name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
          iconName={'icon-card'} headerName={'Forwarded to Payer'} sortIcon={true} type={'string'} colKey={'Farwarded'} data={patientListData} setData={setPatientListData} />),
        resizable: true,
        renderCell: ({ row }) => {
          return (<> {searchParam?.ResultAs === 'Count'
            ? row.Farwarded
            : <AmountFormatter amount={row.Farwarded} />
          }</>)
        },
        renderSummaryCell: () => {
          return (
            searchParam?.ResultAs === 'Count' ? summaryRow?.Farwarded :
              <AmountFormatter amount={summaryRow?.Farwarded} />)
        }

      },
      {
        key: 'Received',
        name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
          iconName={'icon-card'} headerName={'Received'} sortIcon={true} type={'string'} colKey={'Received'} data={patientListData} setData={setPatientListData} />),
        width: 200,
        resizable: true,
        renderCell: ({ row }) => {
          return (<> {searchParam?.ResultAs === 'Count'
            ? row.Received
            : <AmountFormatter amount={row.Received} />
          }</>)
        },
        renderSummaryCell: () => {
          return (
            searchParam?.ResultAs === 'Count' ? summaryRow?.Received :
              <AmountFormatter amount={summaryRow?.Received} />)
        }

      },
      {
        key: 'Accepted',
        name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
          iconName={'icon-card'} headerName={'Accepted'} sortIcon={true} type={'string'} colKey={'Accepted'} data={patientListData} setData={setPatientListData} />),
        resizable: true,
        renderCell: ({ row }) => {
          return (<> {searchParam?.ResultAs === 'Count'
            ? row.Accepted
            : <AmountFormatter amount={row.Accepted} />
          }</>)
        },
        renderSummaryCell: () => {
          return (
            searchParam?.ResultAs === 'Count' ? summaryRow?.Accepted :
              <AmountFormatter amount={summaryRow?.Accepted} />)
        }
      },
      ...(searchParam?.ResultAs !== 'Count' ? [

        {
          key: 'Allowed',
          name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
            iconName={'icon-card'} headerName={'Allowed (ERA)'} sortIcon={true} type={'string'} colKey={'Allowed'} data={patientListData} setData={setPatientListData} />),
          resizable: true,
          renderCell: ({ row }) => { return (<><AmountFormatter amount={row.Allowed} /></>) },
          renderSummaryCell: () => {
            return (
              <AmountFormatter amount={summaryRow?.Allowed} />)
          }
        },
        {
          key: 'CPTAllowedAmount',
          name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
            iconName={'icon-card'} headerName={'Allowed (Sys)'} sortIcon={true} type={'string'} colKey={'CPTAllowedAmount'} data={patientListData} setData={setPatientListData} />),
          resizable: true,
          renderCell: ({ row }) => { return (<><AmountFormatter amount={row.CPTAllowedAmount} /></>) },
          renderSummaryCell: () => {
            return (
              <AmountFormatter amount={summaryRow?.CPTAllowedAmount} />)
          }
        },
      ] : []),
      {
        key: 'Paid',
        name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
          iconName={'icon-card'} headerName={'Paid'} sortIcon={true} type={'string'} colKey={'Paid'} data={patientListData} setData={setPatientListData} />),
        resizable: true,
        renderCell: ({ row }) => {
          return (<> {searchParam?.ResultAs === 'Count'
            ? row.Paid
            : <AmountFormatter amount={row.Paid} />
          }</>)
        },
        renderSummaryCell: () => {
          return (
            searchParam?.ResultAs === 'Count' ? summaryRow?.Paid :
              <AmountFormatter amount={summaryRow?.Paid} />)
        }

      },
      ...(searchParam?.ResultAs !== 'Count' ? [

        {
          key: 'ContAdj',
          name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
            iconName={'icon-card'} headerName={'ContAdj'} sortIcon={true} type={'string'} colKey={'ContAdj'} data={patientListData} setData={setPatientListData} />),
          resizable: true,
          renderCell: ({ row }) => { return (<><AmountFormatter amount={row.ContAdj} /></>) },
          renderSummaryCell: () => {
            return (
              <AmountFormatter amount={summaryRow?.ContAdj} />)
          }

        },
        {
          key: 'WriteOff',
          name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
            iconName={'icon-card'} headerName={'WriteOff'} sortIcon={true} type={'string'} colKey={'WriteOff'} data={patientListData} setData={setPatientListData} />),
          resizable: true,
          renderCell: ({ row }) => { return (<><AmountFormatter amount={row.WriteOff} /></>) },
          renderSummaryCell: () => {
            return (
              <AmountFormatter amount={summaryRow?.WriteOff} />)
          }

        },

      ] : []),

      {
        key: 'Denied',
        name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
          iconName={'icon-card'} headerName={'Denied'} sortIcon={true} type={'string'} colKey={'Denied'} data={patientListData} setData={setPatientListData} />),
        resizable: true,
        renderCell: ({ row }) => {
          return (<> {searchParam?.ResultAs === 'Count'
            ? row.Denied
            : <AmountFormatter amount={row.Denied} />
          }</>)
        },
        renderSummaryCell: () => {
          return (
            searchParam?.ResultAs === 'Count' ? summaryRow?.Denied :
              <AmountFormatter amount={summaryRow?.Denied} />)
        }

      },
      {
        key: 'ReSubmit',
        name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
          iconName={'icon-card'} headerName={'ReSubmit'} sortIcon={true} type={'string'} colKey={'ReSubmit'} data={patientListData} setData={setPatientListData} />),
        resizable: true,
        renderCell: ({ row }) => {
          return (<> {searchParam?.ResultAs === 'Count'
            ? row.ReSubmit
            : <AmountFormatter amount={row.ReSubmit} />
          }</>)
        },
        renderSummaryCell: () => {
          return (
            searchParam?.ResultAs === 'Count' ? summaryRow?.ReSubmit :
              <AmountFormatter amount={summaryRow?.ReSubmit} />)
        }

      },
      {
        key: 'Remaining ',
        name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
          iconName={'icon-card'} headerName={'Remaining '} sortIcon={true} type={'string'} colKey={'Remaining '} data={patientListData} setData={setPatientListData} />),
        resizable: true,
        renderCell: ({ row }) => {
          return (<> {searchParam?.ResultAs === 'Count'
            ? row.Remaining
            : <AmountFormatter amount={row.Remaining} />
          }</>)
        },
        renderSummaryCell: () => {
          return (
            searchParam?.ResultAs === 'Count' ? summaryRow?.Remaining :
              <AmountFormatter amount={summaryRow?.Remaining} />)
        }

      },

    ];

  }, [patientListData, viewThisPage, claimRecord, subGridDataObject]);
  const AllColumnsName = HandleSelectColumnName(columns);

  const [gridVersion, setGridVersion] = useState(0);

  const LoadData = async (searchParam) => {
    if (!searchParam.DOSFrom && !searchParam.EntryDateFrom && !searchParam.SubmittedFrom) {
      NotificationHandler('Date is required', enumUtil.enumtoaster.error);
      return;
    }

    const newPageNo = (isEqual(searchParam, Search_Data) ? PageNo : 1);

    // Reset everything the instant a new search starts — don't wait for the response
    setPatientListData([]);
    setSubGridDataObject({});
    setClaimRecord([]);
    setSelectedRows(new Set());
    setGridVersion(v => v + 1); // forces ReactDataGrid to actually remount
    setIsLoading(true);

    ServerRequestProtected(API_Reports + "/ReportList", 'post', {
      "TableName": enumUtil.enumAPITableName.WEEKSUBMISSIONREPORT,
      "SearchCriteria": searchParam,
      "PerPage": PerPage,
      "PageNo": newPageNo,
    }).then((response) => {
      setIsLoading(false);
      handleGridHeader({ defaultData: response.Rows });
      const newRows = response?.Rows?.map((row, idx) => ({
        ...row,
        // Guaranteed-unique per row, independent of whatever id (or lack of one) the backend sends.
        // Used ONLY for frontend bookkeeping — never sent to the backend.
        _rowKey: `${row.DateRangeStart || row.DateRange || ''}_${row.InsuranceID || ''}_${idx}`,
        type: 'MASTER',
        expanded: false,
      }));
      setDataByWeek(searchParam.DataBy);
      setPatientListData(newRows);
      setTotalCounts(response.Rows.length);
      setTotalPages(response.count.NumOfPages);
      settotalcountSummary(response.count);
      setAllRecordSummary(response.TotalCount);
    }).catch((error) => {
      setIsLoading(false);
      setPatientListData([]);
      setTotalCounts(0);
    });
  };

  const summaryRow = {
    Accepted: viewThisPage === 'false' ? allRecordSummary?.AllAccepted : totalcountSummary?.TotalAccepted,
    Allowed: viewThisPage === 'false' ? allRecordSummary?.AllAllowed : totalcountSummary?.TotalAllowed,
    Billed: viewThisPage === 'false' ? allRecordSummary?.AllBilled : totalcountSummary?.TotalBilled,
    CPTAllowedAmount: viewThisPage === 'false' ? allRecordSummary?.AllCPTAllowedAmount : totalcountSummary?.TotalCPTAllowedAmount,
    ContAdj: viewThisPage === 'false' ? allRecordSummary?.AllContAdj : totalcountSummary?.TotalContAdj,
    Denied: viewThisPage === 'false' ? allRecordSummary?.AllDenied : totalcountSummary?.TotalDenied,
    Farwarded: viewThisPage === 'false' ? allRecordSummary?.AllFarwarded : totalcountSummary?.TotalFarwarded,
    NotBilled: viewThisPage === 'false' ? allRecordSummary?.AllNotBilled : totalcountSummary?.TotalNotBilled,
    Paid: viewThisPage === 'false' ? allRecordSummary?.AllPaid : totalcountSummary?.TotalPaid,
    ReSubmit: viewThisPage === 'false' ? allRecordSummary?.AllReSubmit : totalcountSummary?.TotalReSubmit,
    Received: viewThisPage === 'false' ? allRecordSummary?.AllReceived : totalcountSummary?.TotalReceived,
    Rejected: viewThisPage === 'false' ? allRecordSummary?.AllRejected : totalcountSummary?.TotalRejected,
    Remaining: viewThisPage === 'false' ? allRecordSummary?.AllRemaining : totalcountSummary?.TotalRemaining,
    Total: viewThisPage === 'false' ? allRecordSummary?.AllTotal : totalcountSummary?.TotalTotal,
    WriteOff: viewThisPage === 'false' ? allRecordSummary?.AllWriteOff : totalcountSummary?.TotalWriteOff,
  };
  const bottomSummaryRows = patientListData?.length > 0 ? [summaryRow] : [];

  //-------- SummaryRow--------//
  // const bottomSummaryRows = patientListData?.length > 0 ? [totalcountSummary] : [];

  // const columns = [
  //   {
  //     key: 'DateRange',
  //     name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
  //       iconName={'icon-card'} headerName={dataByWeek === 'Weekly' ? 'Weekly' : dataByWeek === 'Monthly' ? 'Monthly' : dataByWeek === 'Yearly' ? 'Yearly' : ''} sortIcon={true} type={'string'} colKey={'DateRange'} data={patientListData} />),
  //     width: 200,
  //     resizable: true,
  //     renderCell: ({ row }) => {
  //       return (
  //         <>
  //           <div className="align-items-center pri_ins copy_icon copy_icon_hover d-flex gap-1 justify-content-between patient_col w-100">
  //             <div className="copy_icon validation_message">
  //               {row.DateRange}
  //             </div>
  //             {row.DateRange && <div className="icon_copy">
  //               <i className='icon-Icon-ionic-ios-copy' onClick={() => handleCopy(row.LineID, row.DateRange)}></i>
  //               <p class="tool_tip xsm_text text-light">Copy</p>
  //             </div>}
  //             {copiedText[`${row.LineID}-${row.DateRange}`] ? <p className={`xsm_text copied_text d-block`} >Copied to clipboard</p> : <></>}
  //           </div>
  //         </>
  //       );
  //     }
  //   },
  //   {
  //     key: 'InsuranceName',
  //     name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
  //       iconName={'icon-card'} headerName={'Insurance'} sortIcon={true} type={'string'} colKey={'InsuranceName'} data={patientListData} />),
  //     resizable: true,
  //     width: 200,
  //   },
  //   {
  //     key: 'Billed',
  //     name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
  //       iconName={'icon-card'} headerName={'Billed'} sortIcon={true} type={'number'} colKey={'Billed'} data={patientListData} />),
  //     resizable: true,
  //     renderCell: ({ row }) => { return (<><AmountFormatter amount={row.Billed} /></>) },
  //   },
  //   {
  //     key: 'NotBilled',
  //     name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
  //       iconName={'icon-card'} headerName={'Not Billed'} sortIcon={true} type={'number'} colKey={'NotBilled'} data={patientListData} />),
  //     resizable: true,
  //     renderCell: ({ row }) => { return (<><AmountFormatter amount={row.NotBilled} /></>) },
  //   },
  //   {
  //     key: 'Accepted',
  //     name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
  //       iconName={'icon-card'} headerName={'Accepted'} sortIcon={true} type={'string'} colKey={'Accepted'} data={patientListData} />),
  //     resizable: true,
  //   },
  //   {
  //     key: 'Rejected',
  //     name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
  //       iconName={'icon-card'} headerName={'Rejected'} sortIcon={true} type={'string'} colKey={'Rejected'} data={patientListData} />),
  //     width: 200,
  //     resizable: true,
  //   },
  // ];



  useEffect(() => {
    if (!initialLoad.current) {
      initialLoad.current = true;
      return;
    }
    LoadData(searchParam);
  }, [PerPage, PageNo]);
  //
  const rowClass = () => {
    return "row-bg";
  };
  const searchButton = {
    AddNew: false,
    Excel: true,
    PDF: true,
    Delete: false,
    Filter: false,
    View: false
  }
  let valModal = {}
  let ValidationModal = {
    ReceiverIDVal: "",
  };
  const [receiverValidationModal, setReceiverValidationModal] = useState(ValidationModal);
  const ReceiverValidation = async () => {
    if (isNull(searchParam.DOSFrom) && isNull(searchParam.EntryDateFrom) && isNull(searchParam.SubmittedFrom)) {
      let ValidationModal = {
        ReceiverIDVal: FormValidator(
          '',
          enumUtil.enumValidationType.Required,
          'Date',
        ),

      }
      await setReceiverValidationModal(ValidationModal)
      valModal = ValidationModal
    }
    // let dataReceiverID = searchParam.CreateFrom;
    // // [searchParam.DOSFrom,searchParam.DOSTo,searchParam.CreateFrom,searchParam.CreateTo,searchParam.SubmittedFrom,searchParam.SubmittedTo];
    // if (dataReceiverID === null) { dataReceiverID = ""; }

  }

  const handleSelectedData = (selectedData, name, type) => {
    if (type === 'server' && !isNull(selectedData)) {
      if (name === 'CPT') {
        setSearchParam({ ...searchParam, CPT: selectedData.display })
      }
    } else {
      setPateintValue('')
      setSearchParam({ ...searchParam, PatientID: '' })
      setSearchParam({ ...searchParam, CPT: '' })
    }
  }
  const handleCPTChange = (e) => {
    setIs(false)
    setSearchParam({ ...searchParam, CPT: e.target.value })
    setcptBody({ "TableName": enumUtil.enumAPITableName.Procedure, "SearchParam": e.target.value })
  }
  const handleRadioChangeDate = (value) => {
    setSearchParam({ ...searchParam, GroupBy: value });
  };
  const handleRadioChangeWeek = (value) => {
    setSearchParam({ ...searchParam, DataBy: value });

  };
  const handleRadioChangeResultAs = (value) => {
    setSearchParam({ ...searchParam, ResultAs: value });
  };
  const [subGridResponse, setSubGridResponse] = useState([])

  const findRecord = async (cacheKey, insuranceId, row) => {
    setIsLoading(true);
    setSubGridResponse([]);
    try {
      const response = await ServerRequestProtected(API_Reports + "/SubGrid", 'post', {
        "TableName": enumUtil.enumAPITableName.WEEKSUBMISSIONREPORT,
        "ID": insuranceId || null,
        SearchCriteria: {
          DateRangeStart: row.DateRangeStart,
          DateRangeEnd: row.DateRangeEnd,
          PatientID: row.PatientID,
          CPT: row.CPT,
          GroupBy: row.GroupBy,
          ResultAs: row.ResultAs,
          DataBy: row.DataBy,
          DOSFrom: row.DOSFrom,
          DOSTo: row.DOSTo,
          SubmittedFrom: row.SubmittedFrom,
          SubmittedTo: row.SubmittedTo,
          EntryDateFrom: row.EntryDateFrom,
          EntryDateTo: row.EntryDateTo,
        },
      });

      setClaimRecord(response);
      // Cache under the row's own unique key — NOT InsuranceID — so two rows
      // sharing the same insurance never overwrite each other's subgrid data.
      setSubGridDataObject(prev => ({ ...prev, [cacheKey]: response }));
      return response;
    } catch (error) {
      NotificationHandler(error?.response?.data || 'Unable to load details', enumUtil.enumtoaster.error);
      return null;
    } finally {
      setIsLoading(false); // always runs — success, empty, or failure
    }
  }

  const rowKeyGetter = (row) => {
    return row.type === 'MASTER' ? row._rowKey : row.id;
  }

  const onRowSelection = (listOfIds) => {
    let newList = []
    const tempIdsArr = []
    listOfIds.forEach((id) => {
      patientListData?.forEach((el) => {
        if (el.id === id) {
          newList.push(el)
          tempIdsArr.push(id);
        }

      })
    })
    setSelectedRows(listOfIds)
    const commaSeparatedIds = tempIdsArr.join(', ');
    setSelectedClaimID(commaSeparatedIds);
    console.log(commaSeparatedIds)
  }
  // const onRowsChange = async (rows, { indexes }) => {
  //   const row = rows[indexes[0]];
  //   if (row?.type === 'MASTER') {
  //     if (!row?.expanded) {
  //       rows.splice(indexes[0] + 1, 1);
  //     }
  //     else {
  //       let rowz = await findRecord(row?.InsuranceID)
  //       rowz?.forEach((item) => {
  //         const recordExist = SubGridDataObject[item?.InsuranceID]?.some((record) => { return record?.ServiceLineID === item?.ServiceLineID })
  //         if (!recordExist) {
  //           SubGridDataObject = { ...SubGridDataObject, [item?.InsuranceID]: [...(SubGridDataObject[item?.InsuranceID] || []), item] };
  //         }
  //       })
  //       console.log('SUBGRID', SubGridDataObject, indexes)
  //       // if(!isNull(SubGridData)){
  //       rows.splice(indexes[0] + 1, 0, {
  //         type: 'DETAIL',
  //         id: row?.id,
  //         parentId: row?.id,
  //       });
  //       // }
  //     }
  //     setPatientListData(rows)
  //   }
  // }

  const onRowsChange = async (rows, { indexes }) => {
    const row = rows[indexes[0]];
    if (row?.type !== 'MASTER') return;

    if (!row?.expanded) {
      rows.splice(indexes[0] + 1, 1);
      setPatientListData([...rows]);
      return;
    }

    if (!row.InsuranceID) {
      row.expanded = false;
      setPatientListData([...rows]);
      return;
    }

    const rowz = await findRecord(row._rowKey, row.InsuranceID, row);
    if (rowz && rowz.length > 0) {
      rows.splice(indexes[0] + 1, 0, {
        type: 'DETAIL',
        id: `${row._rowKey}_detail`,
        parentId: row._rowKey,
      });
    } else {
      row.expanded = false; // nothing came back — don't leave it stuck "open" with no detail row
    }
    setPatientListData([...rows]);
  }

  const handleClear = () => {
    setSearchParam({ ...Search_Data, GroupBy: "DOS", DataBy: "Weekly", CPT: '' });
    setPateintValue([]);
    setReloadSuperSearchPatient(!reloadSuperSearchPatient);
    setselectedCPT('');
    setClaimRecord([]);
    setPatientListData([]);
    setSubGridDataObject({});
    setSelectedRows(new Set());
    setGridVersion(v => v + 1);
  }
  
  const getRowHeight = (row) => {
    if (row.type === 'DETAIL') {
      const count = subGridDataObject[row.parentId]?.length || 0;
      const heights = { 1: 56, 2: 81, 3: 106, 4: 131 };

      if (count >= 5) return 156;
      return heights[count] ?? 56;
    }
    return 25;
  };


  const handleChange = (e) => {
    setIs(false)
    let { name, value } = e.target

    if (name === 'CPT') {
      setselectedCPT(value)
    }
  }
  const handleSelectedDataa = (selectedData, name, type) => {
    setIs(true)
    if (type === 'client' && !isNull(selectedData)) {
      if (name === 'CPT') {
        setSearchParam({ ...searchParam, CPT: selectedData.value + "", })
        setselectedCPT(selectedData.display)
      }
    } else {
    }
    return selectedData
  }

  return (
    <>
      <div className="container-fluid py-2">
        <div className='row align-items-end'>
          <div className="col-md-12 hk-opt-bar">
            <div className="row row-half row-gap-15 align-items-end">
              <div className="col-md-3 multipleSearch-rounded rounded-full agency-pat-search">
                <div className="input autocomplete-group autocomplete-group-xs">
                  <label htmlFor="">Patient</label>
                  <div className='input-group'>
                    <SuperSearchMultiple
                      key={reloadSuperSearchPatient}
                      type='server'
                      id="PatientID"
                      name="PatientID"
                      SuperSearchView="DetailedView"
                      DetailedView="Patient"
                      onSelect={handleMUltiSelectedData}    // use for get data 
                      initialSelectedValues={patientValue} // comment here the pupose of this , whoever made his
                      initialSelectedOptionsInstant={patientValue} // GETTING USED IN CASE OF INITIAL Value for Instant Search
                      tableName={enumUtil.enumAPITableName.Patient} //send Tablename api
                      searchTerm={patientValue} //for search ipnut  // probably not getting used in this case //test it later
                      controller={API_URL_Patient}
                      ApiLink={"/InstantSearchWithDetails"} //api url 
                      method='post'  //   api method 
                      // postBody={checkBody}
                      // onChange={handleCheckNumberChange}
                      sup_btn='sup_btn-Inp'
                      sup_inp='superSearchVisitInp'
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-3 multipleSearch-rounded">
                <div className="input">
                  <label>Insurance</label>
                  <SuperSearchMultipleClient
                    key={reloadSuperSearchPatient}
                    id="InsuranceID"
                    name="InsuranceID"
                    selectedOptionsDisplay='Insurance'
                    initialSelectedValues={[]}
                    searchParam={searchParam}
                    setSearchParam={setSearchParam}
                    options={DropdownData.Insurance?.filter(item => !['-1', -1].includes(item.value))}
                    sup_btn="sup_btn-Inp"
                    sup_inp="superSearchVisitInp"
                  />
                </div>
              </div>
              <div className="col-md-3">
                <div className="input">
                  <label>Group By</label>
                  <div className="d-flex gap-10 ps-1-5 align-items-center">
                    <div className="ar_radio-btn d-flex align-items-center gap-6">
                      <input
                        type="radio"
                        id="DOS"
                        name="GroupBy"
                        value="DOS"
                        ref={radioInputRef}
                        checked={searchParam.GroupBy === 'DOS'}
                        onChange={() => handleRadioChangeDate('DOS')}
                      />
                      <p className="text ar-orange-text" htmlFor="DOS">DOS</p>
                    </div>
                    <div className="ar_radio-btn d-flex align-items-center gap-6">
                      <input
                        type="radio"
                        id="Created"
                        name="GroupBy"
                        value="Created"
                        ref={radioInputRef}
                        checked={searchParam.GroupBy === 'Created'}
                        onChange={() => handleRadioChangeDate('Created')}
                      />
                      <p className="text ar-orange-text" htmlFor="Created">Created</p>
                    </div>
                    <div className="ar_radio-btn d-flex align-items-center gap-6">
                      <input
                        type="radio"
                        id="Submitted"
                        name="GroupBy"
                        value="Submitted"
                        ref={radioInputRef}
                        checked={searchParam.GroupBy === 'Submitted'}
                        onChange={() => handleRadioChangeDate('Submitted')}
                      />
                      <p className="text ar-orange-text" htmlFor="Submitted">Submitted</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div className="input">
                  <label>Group By</label>

                  <div className="d-flex gap-10 ps-1-5 align-items-center">
                    <div className="ar_radio-btn d-flex align-items-center gap-6">
                      <input
                        type="radio"
                        id="Weekly"
                        name="DataBy"
                        value="Weekly"
                        ref={radioInputRef}
                        checked={searchParam.DataBy === 'Weekly'}
                        onChange={() => handleRadioChangeWeek('Weekly')}
                      />
                      <p className="text ar-orange-text" htmlFor="Weekly">Weekly</p>
                    </div>
                    <div className="ar_radio-btn d-flex align-items-center gap-6">
                      <input
                        type="radio"
                        id="Monthly"
                        name="DataBy"
                        value="Monthly"
                        ref={radioInputRef}
                        checked={searchParam.DataBy === 'Monthly'}
                        onChange={() => handleRadioChangeWeek('Monthly')}
                      />
                      <p className="text ar-orange-text" htmlFor="Monthly">Monthly</p>
                    </div>
                    <div className="ar_radio-btn d-flex align-items-center gap-6">
                      <input
                        type="radio"
                        id="Yearly"
                        name="DataBy"
                        value="Yearly"
                        ref={radioInputRef}
                        checked={searchParam.DataBy === 'Yearly'}
                        onChange={() => handleRadioChangeWeek('Yearly')}
                      />
                      <p className="text ar-orange-text" htmlFor="Yearly">Yearly</p>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <div className="col-md-12 hk-opt-bar ">
            <div className="row row-half row-gap-15 align-items-end mt-1">
              <div className="col-md-3">
                <CalendaRangeInput searchParam={searchParam} setSearchParam={setSearchParam} options={['DOS', 'Entry Date', 'Submitted']} />
                {/* {!isNull(receiverValidationModal.ReceiverIDVal)?receiverValidationModal.ReceiverIDVal:''} */}
              </div>

              <div className="col-md-3 input autocomplete-group autocomplete-group-xs multipleSearch-rounded">
                {/* <div className="input autocomplete-group autocomplete-group-xs "> */}
                {/* <label>CPT</label>
                  <SuperSearchList
                    type='server'
                    id='CPT'
                    name='CPT'
                    searchValue={searchParam.CPT}
                    ApiLink={API_URL_CLAIM + "/CPTInstantSearch"}
                    method='post'
                    postBody={cptBody}
                    onChange={(e) => handleCPTChange(e)}
                    getSelectedData={handleSelectedData}
                    is={is}
                    sup_btn='sup_btn-Inp'
                    sup_inp='superSearchVisitInp'
                    // disabled={true}
                    icon={true}
                    placeholder={"Search..."}
                  /> */}
                <label>CPT</label>
                <SuperSearchList
                  type="client"
                  id='CPT'
                  name='CPT'
                  searchValue={selectedCPT}
                  // data={procedureDD}
                  data={[
                    { display: '', value: '' },
                    ...(procedureDD || [])
                  ]}
                  onChange={(e) => handleChange(e)}
                  getSelectedData={handleSelectedDataa}
                  is={is}
                  icon={'Simple'}
                  sup_btn='sup_btn'
                  sup_inp='superSearchVisitInp'
                />
                {/* </div> */}
              </div>
              <div className="col-md-3">
                <div className="input">
                  <label>Result As</label>
                  <div className="d-flex gap-10 ps-1-5 align-items-center">
                    <div className="ar_radio-btn d-flex align-items-center gap-6">
                      <input
                        type="radio"
                        id="Amounts"
                        name="ResultAs"
                        value="Amounts"
                        ref={radioInputRef}
                        checked={searchParam.ResultAs === 'Amounts'}
                        onChange={() => handleRadioChangeResultAs('Amounts')}
                      />
                      <p className="text ar-orange-text" htmlFor="Amounts">Amounts</p>
                    </div>
                    <div className="ar_radio-btn d-flex align-items-center gap-6">
                      <input
                        type="radio"
                        id="Count"
                        name="ResultAs"
                        value="Count"
                        ref={radioInputRef}
                        checked={searchParam.ResultAs === 'Count'}
                        onChange={() => handleRadioChangeResultAs('Count')}
                      />
                      <p className="text ar-orange-text" htmlFor="Count">Count</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-2 d-flex">
                <div className='btns-group-flex'>
                  <button className='btn btn-orange btn-xs no-width rounded' onClick={() => LoadData(searchParam)}>Search</button>
                  <div className='line-border'></div>
                  <button className='btn btn-outline btn-xs no-width rounded' onClick={() => handleClear()}>Clear</button>
                </div>
              </div>
              <div className="col-md-1 pb-1 no-search-margin ins-aging-record">
                <div className="d-flex justify-content-end gap-1 align-items-center gap-20">
                  <SearchHeader
                    searchButton={searchButton}
                    tableName={enumUtil.enumAPITableName.WEEKSUBMISSIONREPORT}
                    PerPage={PerPage}
                    PageNo={PageNo}
                    TotalPages={TotalPages}
                    Name={"WEEK SUBMISSION REPORT"}
                    searchParam={{ ...searchParam, IsExcelExport: "1" }}
                    isEmpty={patientListData.length > 0}
                    Model={"report"}
                    componentColumns={AllColumnsName}
                    ColumnTableName={'WeeklySubmissionReport'}
                    enabled={ActiveReport?.data.id === 415 && SidebarActive === 4}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="position-relative">
        {isLoading ? <Loader /> : null}
        <ReactDataGrid
          key={gridVersion}
          columns={columns}
          rows={patientListData}
          bottomSummaryRows={bottomSummaryRows}
          onRowsChange={onRowsChange}
          headerRowHeight={25}
          // rowHeight={(args) => (args?.type === 'ROW' && args?.row?.type === 'DETAIL' ? 150 : 25)}
          className={`${Settings?.GridView === 'Borderless Grid' || Settings?.GridView === 'BorderlessGrid' ? 'serviceline-grid' : ''} fill-grid DataGrid-Table custom_checkboxes_gird two-rows-with-tab hk-exp-table`}
          // className='fill-grid DataGrid-Table custom_checkboxes_gird templates hk-exp-table'
          enableVirtualization={false}
          style={{ userSelect: 'text', height: '500px' }}
          rowKeyGetter={rowKeyGetter}
          selectedRows={selectedRows}
          onSelectedRowsChange={onRowSelection}
          PerPage={PerPage}
          PageNo={PageNo}
          TotalPages={TotalPages}
          Counts={totalCounts}
          handlePageClick={handlePageClick}
          PreviousPage={PreviousPage}
          handleFingByCreteria={handleFingByCreteria}
          NextPage={NextPage}
          rowHeight={getRowHeight}
        />
        {!isLoading ?
          <NoDataFound isLoading={isLoading} rows={patientListData} />
          : null
        }
        {/* {paginationSection} */}

        <Pagination
          PerPage={PerPage}
          PageNo={PageNo}
          TotalPages={TotalPages}
          Counts={totalCounts}
          handlePageClick={handlePageClick}
          PreviousPage={PreviousPage}
          handleFingByCreteria={handleFingByCreteria}
          NextPage={NextPage}
          Key={415}
          handleSelectData={handleSelectData}
          LoadData={() => LoadData(searchParam)}
          ClearSearch={handleClear}
        />
      </div>
    </>
  )
}
// const mapStateToProps = (state) => {
//   return {
//     Settings: state.SettingsReducer,
//   }
// }
function mapStateToPropss(state) {
  return {
    OpenDynamicTab: state.Open_Claim_Tab ? state.Open_Claim_Tab : [],
    Settings: state.SettingsReducer,
  };
}
const action = {
  TabActionClaims,
};
export default connect(mapStateToPropss, action)(PatientList);
// export default connect(mapStateToProps)(PatientList)
// const SubGridColumns = [
//   { key: 'Patient', name: 'Patient', width: 180 },
//   { key: 'Billed', name: 'Billed', renderCell({ row }) { return (<AmountFormatter amount={row.Billed} />); }, },
//   { key: 'NotBilled', name: 'Not Billed', renderCell({ row }) { return (<AmountFormatter amount={row.NotBilled} />); }, },
//   { key: 'Farwarded', name: ' Farwarded to Payer', renderCell({ row }) { return (<AmountFormatter amount={row.Farwarded} />); }, },
//   { key: 'Received', name: 'Received By Payer', renderCell({ row }) { return (<AmountFormatter amount={row.Received} />); }, },
//   { key: 'Accepted', name: 'Accepted', renderCell({ row }) { return (<AmountFormatter amount={row.Accepted} />); }, },
//   { key: 'Rejected', name: 'Rejected', renderCell({ row }) { return (<AmountFormatter amount={row.Rejected} />); }, },
// ];


const SubGridColumns = (subGridDataObject, claimRecord) => [
  { key: 'Patient', name: 'Patient', width: 180 },
  { key: 'Billed', name: 'Billed', renderCell({ row }) { return (<AmountFormatter amount={row.Billed} />); }, },
  { key: 'NotBilled', name: 'Not Billed', renderCell({ row }) { return (<AmountFormatter amount={row.NotBilled} />); }, },
  { key: 'Farwarded', name: ' Farwarded to Payer', renderCell({ row }) { return (<AmountFormatter amount={row.Farwarded} />); }, },
  { key: 'Received', name: 'Received By Payer', renderCell({ row }) { return (<AmountFormatter amount={row.Received} />); }, },
  { key: 'Accepted', name: 'Accepted', renderCell({ row }) { return (<AmountFormatter amount={row.Accepted} />); }, },
  { key: 'Rejected', name: 'Rejected', renderCell({ row }) { return (<AmountFormatter amount={row.Rejected} />); }, },
];
function SubGrid({ isCellSelected, parentId, row, subGridDataObject, claimRecord }) {
  useEffect(() => {
    if (!isCellSelected)
      return;
  }, [isCellSelected]);
  const rowCount = subGridDataObject[row.parentId]?.length || 0;

  const rowClass = rowCount <= 4 ? `row-${rowCount}` : "";
  return (
    <>

      {subGridDataObject[parentId]?.length > 0 ? (
        <ReactDataGrid
          rows={subGridDataObject[parentId]?.length > 0 ? subGridDataObject[parentId] : []}
          columns={SubGridColumns(subGridDataObject, claimRecord)}
          rowHeight={25}
          className={`popper-detailed-table claim_inner_grid ar_subgrid_design  ${rowClass}`}

        />
      ) : null}
    </>
  );
}